import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
import { PageHero } from '../components/PageHero';
import { QuoteForm } from '../components/QuoteForm';
import { SITE } from '../lib/site';
export function Contact() {
  const contactItems = [{
    icon: PhoneIcon,
    label: 'Call or Text',
    value: SITE.phoneDisplay,
    href: SITE.phoneHref
  }, {
    icon: MailIcon,
    label: 'Email',
    value: SITE.email,
    href: `mailto:${SITE.email}`
  }, {
    icon: MapPinIcon,
    label: 'Service Area',
    value: SITE.area
  }, {
    icon: ClockIcon,
    label: 'Hours',
    value: SITE.hours
  }];
  return <>
      <PageHero eyebrow="Contact" title={<>Ready when <span className="text-jk-red" data-id="element-159" data-mp="12yqzdfsgivzb">you are</span></>} subtitle="Call, text, or fill out the form. Tell us what needs hauling and we'll get you a free estimate fast." data-id="element-158" data-mp="17rtn37ajzb7l" />

      <section className="bg-jk-ink py-20" data-id="element-160" data-mp="abmmypr1bfdi">
        <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-2" data-id="element-161" data-mp="aauuvownbzrz">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-162" data-mp="15exav8v6kb2y">
            <h2 className="font-display text-3xl font-extrabold uppercase text-white" data-id="element-163" data-mp="1e78plxgxma33">Reach the Kings</h2>
            <p className="mt-2 text-white/60" data-id="element-164" data-mp="1j73drt9bolkg">The fastest way to get on the schedule is a quick call.</p>

            <a href={SITE.phoneHref} className="mt-6 flex items-center justify-center gap-3 rounded-xl bg-jk-red px-5 py-4 font-display text-2xl font-extrabold uppercase tracking-wide text-white transition-transform hover:scale-[1.02] hover:bg-jk-redDark sm:px-6 sm:py-5 sm:text-3xl" data-id="element-165" data-mp="mhchbohh0oc0">
              <PhoneIcon className="h-6 w-6 sm:h-7 sm:w-7" data-id="element-166" data-mp="10hx38tion09q" /> {SITE.phoneDisplay}
            </a>

            <div className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-167" data-mp="26vwd7zp5lbjt">
              {contactItems.map(c => {
              const inner = <>
                    <div className="inline-flex h-11 w-11 items-center justify-center rounded-lg bg-jk-red/15 text-jk-red" data-id="element-168" data-mp="1m6u2clj31zdh">
                      <c.icon className="h-5 w-5" data-id="element-169" data-mp="1h7h8vhxphu1x" />
                    </div>
                    <div className="mt-3 text-xs uppercase tracking-wide text-white/45" data-id="element-170" data-mp="1w5t3lj1iqsqg">{c.label}</div>
                    <div className="font-display text-lg font-bold text-white" data-id="element-171" data-mp="1r66rxe1c9kjr">{c.value}</div>
                  </>;
              return c.href ? <a key={c.label} href={c.href} className="rounded-xl border border-white/10 bg-jk-panel p-5 transition-colors hover:border-jk-red/50" data-id="element-172" data-mp="yhst4w2fek75">
                    {inner}
                  </a> : <div key={c.label} className="rounded-xl border border-white/10 bg-jk-panel p-5" data-id="element-173" data-mp="18ffd3wyl11xz">{inner}</div>;
            })}
            </div>

            <div className="mt-6 overflow-hidden rounded-xl border border-white/10" data-id="element-174" data-mp="ko1g3dphki6o">
              <iframe title="Service area map" className="h-56 w-full grayscale" loading="lazy" src="https://www.google.com/maps?q=Ardmore%2C%20Oklahoma&output=embed" data-id="element-175" data-mp="fr1d5bnxnvjs" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-176" data-mp="2hi1tnhljmron">
            <QuoteForm data-id="element-177" data-mp="3a5xlo9063vf3" />
          </motion.div>
        </div>
      </section>
    </>;
}